import React, { Fragment, useEffect } from 'react';
import { signOut } from '../../reducers/signin';
import { connect } from 'react-redux';
import { BounceLoader } from 'react-spinners';

function SignOut(props) {
    const {
        signOut,
    } = props;

    signOut();

    return (<Fragment>
        <div className="d-flex align-items-center flex-column vh-100 
                       justify-content-center text-center py-3">
            <div className="d-flex align-items-center flex-column px-4">
                <BounceLoader color={'#5383ff'} loading={true} />
            </div>
            <div className="text-muted font-size-xl text-center pt-3">
                Signing Out....
            </div>
        </div>
    </Fragment>);
}


const mapDispatchToProps = dispatch => ({
    signOut: () => dispatch(signOut())
});

export default connect(null, mapDispatchToProps)(SignOut);
